<template>
  <router-view />
</template>

<script>
export default {
  name: "app-frontend"
};
</script>

<style lang="scss" scoped></style>
